import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Conversations } from '../../../model/conversations';
import { Config } from '../config';
import { StorageService } from '../../managers/storage.service';
import { Subject } from "rxjs/Subject";

@Injectable({
  providedIn: 'root'
})
export class ConversationService extends Config {

  constructor(private httpClient: HttpClient, private storageService: StorageService) {
    super();
  }

  public $staffid = new Subject<any>();
  

  public createConversation(conversation: Conversations) {
    var url;

    url = this.BASE_URL + "conversations_create";

    return this.httpClient.post(url, conversation, this.storageService.getHeaders());
  }

  public getConversations(reqObj: any) {
    let url;
    let isAdmin;

    // isAdmin = this.storageService.isAdmin();
    isAdmin = true;

    url = this.BASE_URL + "conversations_get?user_id=" + (reqObj.user_id) +
      "&maxItemPerPage=" + reqObj.maxItemPerPage + "&page=" + reqObj.page +
      "&keyword=" + reqObj.keyword + "&filter_type=" + reqObj.filter_type;

    return this.httpClient.get(url, this.storageService.getHeaders());
  }

  public getConversationsWithUnreadMessages(reqObj: any) {
    let url;
    let isAdmin;

    // isAdmin = this.storageService.isAdmin();
    isAdmin = true;

    url = this.BASE_URL + "conversations_get_unread_messages?user_id=" + (reqObj.user_id) +
      "&maxItemPerPage=" + reqObj.maxItemPerPage + "&page=" + reqObj.page +
      "&keyword=" + reqObj.keyword;

    return this.httpClient.get(url, this.storageService.getHeaders());
  }


  public getConversationsWithOutgoingMessages(reqObj: any) {
    let url;
    let isAdmin;

    // isAdmin = this.storageService.isAdmin();
    isAdmin = true;

    url = this.BASE_URL + "conversations_get_outgoing_messages?user_id=" + (reqObj.user_id) +
      "&maxItemPerPage=" + reqObj.maxItemPerPage + "&page=" + reqObj.page +
      "&keyword=" + reqObj.keyword;

    return this.httpClient.get(url, this.storageService.getHeaders());
  }

  public getCountConversationsWithOutgoingMessages(reqObj: any) {
    let url;
    let isAdmin;

    // isAdmin = this.storageService.isAdmin();
    isAdmin = true;

    url = this.BASE_URL + "count_cv_get_outgoing_message?user_id=" + (reqObj.user_id);

    return this.httpClient.get(url, this.storageService.getHeaders());
  }


  public getCountConversationsWithUnreadMessages(reqObj: any) {
    let url;
    let isAdmin;

    // isAdmin = this.storageService.isAdmin();
    isAdmin = true;

    url = this.BASE_URL + "count_cv_get_unread_message?user_id=" + (reqObj.user_id);

    return this.httpClient.get(url, this.storageService.getHeaders());
  }

  public getConversationByContactNumberID(userID: number, contactNumberID: number) {
    let url;

    url = this.BASE_URL + "conversations_get_by_contactNumberID?contact_number_id=" + contactNumberID + "&user_logged_id=" + userID;

    return this.httpClient.get(url, this.storageService.getHeaders());
  }

  public setConversationRead(conversationID: number) {
    let url;

    url = this.BASE_URL + "conversations_set_read?conversation_id=" + conversationID;

    return this.httpClient.get(url, this.storageService.getHeaders());
  }
}
